import type { TileListItem } from '@tilelist/domain/composition/TileListitem.ts';

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

/*                                                                          */
/*                          */
/*                                                                          */

/**
 *
 *
 */
export const TOP_KUVO_FEATURE_INDEX = 1;

/**
 *
 *
 *
 *
 */
export const FOOTER_FEATURE_INDEX = -1;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export type FeatureIndexOffset = 0 | 1 | 2;

/*                                                                          */
/*                                        */
/*                                                                          */

/**
 *
 *
 *
 *
 *
 *
 *
 */
export type FeatureIndexInfo = {
    featureIndex: number;
    tilelistSlotIndex?: number;
};

/**
 *
 *
 *
 *
 *
 *
 *
 */
export type FeatureIndices = ReadonlyMap<number, FeatureIndexInfo>;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function computeFeatureIndices(
    items: ReadonlyArray<TileListItem>,
    featureIndexOffset: FeatureIndexOffset,
    includeBenefitCinema = true,
    includeSdaHoarding = true,
): FeatureIndices {
    const map = new Map<number, FeatureIndexInfo>();
    let tilelistSlotCounter = 0;
    let featureCounter = featureIndexOffset;

    items.forEach((item, i) => {
        if (item.type === 'SponsoredDisplayAd') {
            if (!includeSdaHoarding) return;
            map.set(i, { featureIndex: ++featureCounter });
        } else if (item.type === 'BenefitCinema') {
            if (!includeBenefitCinema) return;
            map.set(i, {
                featureIndex: ++featureCounter,
                tilelistSlotIndex: ++tilelistSlotCounter,
            });
        }
    });

    return map;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function getTopSlotSdaFeatureIndex(topKuvoSlotRendered: boolean, topSdaSlotRendered = true): FeatureIndexOffset {
    if (!topSdaSlotRendered) return topKuvoSlotRendered ? 1 : 0;
    return topKuvoSlotRendered ? 2 : 1;
}

/*                                                                          */
/*                               */
/*                                                                          */

/**
 *
 *
 *
 */
export type ExternalAttributes = Partial<
    Record<'data-feature-index' | 'data-footer-slot' | 'data-top-slot' | 'data-tilelist-slot', number | undefined>
>;

/**
 *
 *
 *
 *
 *
 *
 */
export type KuvoPosition = 'top' | 'list';

/**
 *
 *
 *
 */
export type KuvoAttributesInput =
    | { position: 'top' }
    | { position: 'list'; tilelistSlotIndex: number; featureIndex: number };

/**
 *
 *
 *
 *
 */
export function kuvoAttributes(input: KuvoAttributesInput): ExternalAttributes {
    return input.position === 'top'
        ? {
              'data-top-slot': 1,
              'data-feature-index': TOP_KUVO_FEATURE_INDEX,
          }
        : {
              'data-tilelist-slot': input.tilelistSlotIndex,
              'data-feature-index': input.featureIndex,
          };
}

/**
 *
 *
 *
 *
 */
export function sdaHoardingAttributes(featureIndex: number | undefined): ExternalAttributes {
    return { 'data-feature-index': featureIndex };
}

/**
 *
 *
 *
 */
export const footerAttributes: ExternalAttributes = {
    'data-footer-slot': 1,
    'data-feature-index': FOOTER_FEATURE_INDEX,
};
